import { TemplateEngineConfigs } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

import { TouchPointHelper } from '../../helpers/touchPointHelper';
import {
	_root,
	requestContact,
	serviceError,
	subscriptionConclusion,
	subscriptionResumeAndAuthorization,
	subscriptionSelectAccount,
	subscriptionPaymentOptions,
	subscriptionTermsAndConditionsBank,
	intro,
	subscriptionCorporateData,
	subscriptionIntegratorData,
	accessDenied,
} from './prisms';

const templateEngineConfigs: TemplateEngineConfigs = {
	metadata: {
		projectInstanceId: 1,
		projectArtifactInstanceId: 1,
		channelTouchPointId: 1,
		channelTouchPointType: null,
		channelTouchPointDefaultOrientation: null,
		channelTouchPointDefaultPreviousPagesQuantity: 0,
		channelTouchPointDefaultNextPagesQuantity: 0,
		formFactorType: null,
		formFactorShape: null,
		formFactorReferenceSize: null,
	},
	uiPrisms: {
		prisms: [
			_root,
			intro,
			accessDenied,
			requestContact,
			serviceError,
			subscriptionConclusion,
			subscriptionResumeAndAuthorization,
			subscriptionSelectAccount,
			subscriptionPaymentOptions,
			subscriptionTermsAndConditionsBank,
			subscriptionCorporateData,
			subscriptionIntegratorData,
		],
	},
	uiModelComponents: TouchPointHelper.getUiModelPlaceholders(),
};

export default templateEngineConfigs;
